"use client";

import { useTranslations } from "next-intl";
interface TProps {
  messageKey: string;
  email?: string;
}

export const T = ({ messageKey, email }: TProps) => {
  const t = useTranslations();

  return t.rich(messageKey, {
    email: email || "",
    strong: (chunks) => <span className="font-medium">{chunks}</span>,
  });
};
